"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ValidationHelper_1 = require("./ValidationHelper");
function MaxLength(value) {
    return (target, propertyKey, parameterIndex) => {
        const maxLengthValidator = (fieldValue) => {
            if (fieldValue.length !== undefined && fieldValue.length > value) {
                return `Value cannot be longer than ${value}`;
            }
            return null;
        };
        ValidationHelper_1.addValidationRule(target, parameterIndex, maxLengthValidator);
    };
}
exports.MaxLength = MaxLength;
